module.exports = __webpack_public_path__ + "static/bg-gradient-26cbf190e31a2195b46c9bcb553a412e.png";